import styled from '@emotion/styled'
import { TreeSelect } from 'antd'

const { TreeNode } = TreeSelect

export const StyledHierarchySelect = styled(TreeSelect)`
  width: 100%;
  box-sizing: border-box;
  min-height: var(--ess-field-height, 32px);

  &:not(.ant-select-disabled) {
    & .ant-select-selector {
      border-color: ${({ error, theme }) =>
        error ? theme.input.error : theme.input.borderColor};
      border-radius: var(--ess-field-radius, 4px);

      .ant-select-selection-placeholder,
      .ant-select-selection-item-content {
        font-size: 14px;
      }
    }
    &:hover .ant-select-selector {
      border: 1px solid
        ${({ error, theme }) => (error ? theme.input.error : theme.input.hover)};
      border-right-width: 1px !important;
    }

    &.ant-select-focused .ant-select-selector {
      border: 1px solid
        ${({ error, theme }) => (error ? theme.input.error : theme.input.focus)};
      border-right-width: 1px !important;
      outline: 0;
      box-shadow: 0 0 2px 2px
        ${({ error, theme }) =>
          error ? theme.input.errorShadow : theme.input.shadow};
    }
  }
`

export const StyledTreeNode = styled(TreeNode)`
  width: 100%;
`

// border: 1px solid #f44336
